import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class AppsService {

    constructor(
        private http: HttpClient
    ) { }

    // Get all apps
    public getAllApps(pagination, sort) {

        let paginationString = '';
        paginationString += '?size=' + pagination.size;
        paginationString += '&page=' + pagination.page;

        const sortString = '&sort=' + sort;
        return this.http.get(environment.apiUrl + 'api/ext-app' + paginationString + sortString, { observe: 'response' })
            .pipe(map(this.handleDataWithHeaders))
            .pipe(catchError(this.handleError));
    }

    // Get all apps by group id
    public getAllGroupApps(groupid) {
        return this.http.get(environment.apiUrl + 'api/ext-app/by-group-user/' + groupid)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Get app by id
    public getAppById(id) {
        return this.http.get(environment.apiUrl + 'api/ext-app/' + id)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Create app
    public createApp(name) {
        const body = {
            name: name
        };
        return this.http.post(environment.apiUrl + 'api/ext-app', body)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Edit app
    public editApp(obj) {
        const body = {
            id: obj.id,
            name: obj.name
        };
        return this.http.put(environment.apiUrl + 'api/ext-app', body)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Delete app
    public deleteApp(id) {
        return this.http.delete(environment.apiUrl + 'api/ext-app/' + id)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // HANDLE DATA
    private handleData(res: HttpResponse<any>) {
        const body = res;
        return body;
    }


    public handleDataWithHeaders(res: HttpResponse<any>) {

        const headers = res.headers;
        const body = res.body;
        const data = {
            'headers': headers,
            'body': body
        };
        return data;
    }


    private handleError(error: any) {
        return Observable.throw(
            new HttpErrorResponse(error)
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/_services/apps.service.ts